import React, { useEffect, useState } from 'react';
import { FlameIcon } from 'lucide-react';
const TOTAL_SECONDS = 25 * 60;
function pad(value: number): string {
  return value.toString().padStart(2, '0');
}
export function CountdownBar() {
  const [remaining, setRemaining] = useState<number>(TOTAL_SECONDS);
  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(prev => prev <= 1 ? TOTAL_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const minutes = Math.floor(remaining / 60);
  const seconds = remaining % 60;
  return <div className="sticky top-0 z-50 w-full border-b-2 border-ink bg-brand text-white" data-id="element-35" data-mp="2hhn76gbmukp4">
      <div className="mx-auto flex max-w-6xl items-center justify-center gap-x-3 whitespace-nowrap px-4 py-2 sm:py-2.5" data-id="element-36" data-mp="2ciadbbmcgdd1">
        <FlameIcon className="h-4 w-4 shrink-0 text-volt" aria-hidden="true" data-id="element-37" data-mp="aoumoeq9ayi2" />
        <span className="font-display text-xs tracking-[0.08em] sm:text-sm" data-id="element-38" data-mp="amqevlp8lfci">
          <span className="hidden sm:inline" data-id="element-39" data-mp="6nr7lug196hw">¡Oferta de lanzamiento! </span>
          Termina en
        </span>
        <span className="flex items-center gap-1 tabular-nums" aria-live="off" data-id="element-40" data-mp="13g3lhf21d3ni">
          <span className="rounded-md bg-ink px-2 py-1 font-display text-sm leading-none text-volt sm:text-base" data-id="element-41" data-mp="18eonnk0ulxel">
            {pad(minutes)}
          </span>
          <span className="font-display text-sm text-white/80" data-id="element-42" data-mp="yee7prnfibvq">:</span>
          <span className="rounded-md bg-ink px-2 py-1 font-display text-sm leading-none text-volt sm:text-base" data-id="element-43" data-mp="ygqzewizo0lz">
            {pad(seconds)}
          </span>
          <span className="ml-1 text-[10px] font-bold uppercase tracking-[0.14em] text-white/80" data-id="element-44" data-mp="1r2a2urxcnvqe">
            min
          </span>
        </span>
      </div>
    </div>;
}